/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AnnouncementBaseResponse {
  /**
   * Unique id within the system
   * @format int32
   */
  Id: number
  /** Name */
  Name: string
  /**
   * Unique id of the user within the system
   * @format int32
   */
  LastUpdatedByUserId: number
  /**
   * Creation date
   * @format date-time
   */
  CreatedOn: string
  /**
   * Update date
   * @format date-time
   */
  UpdatedOn: string
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
  /**
   *
   *
   * 1 = System
   *
   * 2 = Content
   */
  ReadScope: ArticleReadScope
  /**
   *
   *
   * 0 = Information
   *
   * 1 = Notification
   *
   * 2 = Alert
   */
  Severity: AnnouncementSeverity
  /**
   *
   *
   * 0 = System
   *
   * 1 = Tenant
   *
   * 2 = Corporation
   */
  Scope: AnnouncementScope
  /**
   *
   *
   * 1 = Mobile
   *
   * 2 = Web
   *
   * 255 = All
   */
  Platform: AnnouncementPlatform
  /**
   * Unique id of the tenant within the system
   * @format int32
   */
  TenantId: number
  /**
   * Announcement start date
   * @format date-time
   */
  StartDate: string
  /**
   * Announcement expiration date
   * @format date-time
   */
  ExpiryDate: string
}

export interface AnnouncementBaseResponsePagedItemsResponse {
  /** Items */
  Items: AnnouncementBaseResponse[]
  /**
   * Total count
   * @format int32
   */
  TotalCount: number
}

export interface AnnouncementCreateRequest {
  /**
   * Display name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  Content: ArticleContentCreateRequest
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
  /**
   *
   *
   * 0 = Information
   *
   * 1 = Notification
   *
   * 2 = Alert
   */
  Severity: AnnouncementSeverity
  /**
   * Announcement start date
   * @format date-time
   */
  StartDate: string
  /**
   * Announcement expiry date
   * @format date-time
   */
  ExpiryDate: string
  /**
   *
   *
   * 1 = Mobile
   *
   * 2 = Web
   *
   * 255 = All
   */
  Platform: AnnouncementPlatform
}

/**
 *
 *
 * 1 = Mobile
 *
 * 2 = Web
 *
 * 255 = All
 * @format int32
 */
export enum AnnouncementPlatform {
  Mobile = 1,
  Web = 2,
  All = 255,
}

export interface AnnouncementResponse {
  /**
   * Unique id within the system
   * @format int32
   */
  Id: number
  /** Name */
  Name: string
  /**
   * Unique id of the user within the system
   * @format int32
   */
  LastUpdatedByUserId: number
  /**
   * Creation date
   * @format date-time
   */
  CreatedOn: string
  /**
   * Update date
   * @format date-time
   */
  UpdatedOn: string
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
  /**
   *
   *
   * 1 = System
   *
   * 2 = Content
   */
  ReadScope: ArticleReadScope
  /**
   *
   *
   * 0 = Information
   *
   * 1 = Notification
   *
   * 2 = Alert
   */
  Severity: AnnouncementSeverity
  /**
   *
   *
   * 0 = System
   *
   * 1 = Tenant
   *
   * 2 = Corporation
   */
  Scope: AnnouncementScope
  /**
   *
   *
   * 1 = Mobile
   *
   * 2 = Web
   *
   * 255 = All
   */
  Platform: AnnouncementPlatform
  /**
   * Unique id of the tenant within the system
   * @format int32
   */
  TenantId: number
  /**
   * Announcement start date
   * @format date-time
   */
  StartDate: string
  /**
   * Announcement expiration date
   * @format date-time
   */
  ExpiryDate: string
  Content: ArticleContentResponse
}

/**
 *
 *
 * 0 = System
 *
 * 1 = Tenant
 *
 * 2 = Corporation
 * @format int32
 */
export enum AnnouncementScope {
  System = 0,
  Tenant = 1,
  Corporation = 2,
}

/**
 *
 *
 * 0 = Information
 *
 * 1 = Notification
 *
 * 2 = Alert
 * @format int32
 */
export enum AnnouncementSeverity {
  Information = 0,
  Notification = 1,
  Alert = 2,
}

export interface AnnouncementSeverityUpdateRequest {
  /**
   *
   *
   * 0 = Information
   *
   * 1 = Notification
   *
   * 2 = Alert
   */
  Severity: AnnouncementSeverity
}

export interface AnnouncementUpdateRequest {
  /**
   * Display name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  Content: ArticleContentCreateRequest
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
  /**
   *
   *
   * 0 = Information
   *
   * 1 = Notification
   *
   * 2 = Alert
   */
  Severity: AnnouncementSeverity
  /**
   * Announcement start date
   * @format date-time
   */
  StartDate: string
  /**
   * Announcement expiry date
   * @format date-time
   */
  ExpiryDate: string
  /**
   *
   *
   * 1 = Mobile
   *
   * 2 = Web
   *
   * 255 = All
   */
  Platform: AnnouncementPlatform
}

export interface AnnouncementsMarkAsReadRequest {
  /**
   * Announcement ids
   * @minItems 1
   */
  AnnouncementIds: number[]
}

export interface ApiErrorResponse {
  Error: Error
}

export interface ArticleContentCreateRequest {
  /**
   *
   *
   * 1 = Html
   *
   * 2 = Pdf
   */
  Type: ArticleContentType
  /**
   * Article content
   * @minLength 1
   */
  Content: string
}

export interface ArticleContentResponse {
  /**
   *
   *
   * 1 = Html
   *
   * 2 = Pdf
   */
  Type: ArticleContentType
  /** Article content */
  Content: string
}

/**
 *
 *
 * 1 = Html
 *
 * 2 = Pdf
 * @format int32
 */
export enum ArticleContentType {
  Html = 1,
  Pdf = 2,
}

/**
 *
 *
 * 0 = Draft
 *
 * 1 = Published
 * @format int32
 */
export enum ArticlePublicationStatus {
  Draft = 0,
  Published = 1,
}

/**
 *
 *
 * 1 = System
 *
 * 2 = Content
 * @format int32
 */
export enum ArticleReadScope {
  System = 1,
  Content = 2,
}

export interface ArticleStatusUpdateRequest {
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
}

export interface ContentTrainingMaterialMarkAsReadRequest {
  /**
   * Content training material id
   * @format int32
   */
  ContentTrainingMaterialId: number
}

export interface ContentTrainingMaterialResponse {
  /**
   * Unique id of the content training material within the system
   * @format int32
   */
  Id: number
  /**
   * Creation date
   * @format date-time
   */
  CreatedOn: string
  TrainingMaterial: TrainingMaterialBaseResponse
  /**
   * Unique id of the content within the system
   * @format int32
   */
  ContentId: number
  /** Content name */
  ContentName: string
  /** Assigned */
  Assigned: boolean
  /**
   * Assigned on
   * @format date-time
   */
  AssignedOn?: string | null
  /** Read */
  Read: boolean
  /**
   * Read on
   * @format date-time
   */
  ReadOn?: string | null
}

export interface ContentTrainingMaterialResponsePagedItemsResponse {
  /** Items */
  Items: ContentTrainingMaterialResponse[]
  /**
   * Total count
   * @format int32
   */
  TotalCount: number
}

export interface ContentTrainingMaterialUserResponse {
  /**
   * Unique id of content training material user within the system
   * @format int32
   */
  Id: number
  /**
   * Assigment date
   * @format date-time
   */
  CreatedOn: string
  /**
   * Unique id of the user within the system
   * @format int32
   */
  UserId: number
  /**
   * Unique id of the content training material within the system
   * @format int32
   */
  ContentTrainingMaterialId: number
  /** Read status */
  Read: boolean
  /**
   * Read on
   * @format date-time
   */
  ReadOn?: string | null
}

export interface ContentTrainingMaterialUsersAssignRequest {
  /**
   * Unique ids of the users within the system
   * @minItems 1
   */
  UserIds: number[]
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface TrainingMaterialAttachRequest {
  /**
   * Unique id of the training material within the system
   * @format int32
   */
  TrainingMaterialId: number
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Unique ids of assigned users within the system
   * @minItems 0
   */
  UserIds: number[]
}

export interface TrainingMaterialBaseResponse {
  /**
   * Unique id within the system
   * @format int32
   */
  Id: number
  /** Name */
  Name: string
  /**
   * Unique id of the user within the system
   * @format int32
   */
  LastUpdatedByUserId: number
  /**
   * Creation date
   * @format date-time
   */
  CreatedOn: string
  /**
   * Update date
   * @format date-time
   */
  UpdatedOn: string
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
  /**
   *
   *
   * 1 = System
   *
   * 2 = Content
   */
  ReadScope: ArticleReadScope
}

export interface TrainingMaterialBaseResponsePagedItemsResponse {
  /** Items */
  Items: TrainingMaterialBaseResponse[]
  /**
   * Total count
   * @format int32
   */
  TotalCount: number
}

export interface TrainingMaterialCreateRequest {
  /**
   * Display name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  Content: ArticleContentCreateRequest
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
  /**
   *
   *
   * 1 = System
   *
   * 2 = Content
   */
  ReadScope: ArticleReadScope
}

export interface TrainingMaterialResponse {
  /**
   * Unique id within the system
   * @format int32
   */
  Id: number
  /** Name */
  Name: string
  /**
   * Unique id of the user within the system
   * @format int32
   */
  LastUpdatedByUserId: number
  /**
   * Creation date
   * @format date-time
   */
  CreatedOn: string
  /**
   * Update date
   * @format date-time
   */
  UpdatedOn: string
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
  /**
   *
   *
   * 1 = System
   *
   * 2 = Content
   */
  ReadScope: ArticleReadScope
  Content: ArticleContentResponse
}

export interface TrainingMaterialUpdateRequest {
  /**
   * Display name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  Content: ArticleContentCreateRequest
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   */
  Status: ArticlePublicationStatus
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api.collaborate.local:44395/development/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Article service api
 * @version v1
 * @baseUrl https://api.collaborate.local:44395/development/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  announcements = {
    /**
     * No description
     *
     * @tags Announcements
     * @name GetAsync
     * @summary Request is used to get announcement by id
     * @request GET:/article-service/api/announcements/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<AnnouncementResponse, ApiErrorResponse>({
        path: `/article-service/api/announcements/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name UpdateAsync
     * @summary Request is used to update announcement
     * @request PUT:/article-service/api/announcements/{id}
     * @secure
     */
    updateAsync: (id: number, data: AnnouncementUpdateRequest, params: RequestParams = {}) =>
      this.http.request<AnnouncementResponse, ApiErrorResponse | void>({
        path: `/article-service/api/announcements/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name DeleteAsync
     * @summary Request is used to delete announcement
     * @request DELETE:/article-service/api/announcements/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/article-service/api/announcements/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name GetAllAsync
     * @summary Request is used to get paged announcements
     * @request GET:/article-service/api/announcements
     * @secure
     */
    getAllAsync: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         * @default 50
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AnnouncementBaseResponsePagedItemsResponse, ApiErrorResponse>({
        path: `/article-service/api/announcements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name CreateSystemAnnouncementAsync
     * @summary Request is used to create system announcement
     * @request POST:/article-service/api/announcements/system
     * @secure
     */
    createSystemAnnouncementAsync: (data: AnnouncementCreateRequest, params: RequestParams = {}) =>
      this.http.request<AnnouncementResponse, ApiErrorResponse | void>({
        path: `/article-service/api/announcements/system`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name CreateTenantAnnouncementAsync
     * @summary Request is used to create tenant announcement
     * @request POST:/article-service/api/announcements/tenant
     * @secure
     */
    createTenantAnnouncementAsync: (data: AnnouncementCreateRequest, params: RequestParams = {}) =>
      this.http.request<AnnouncementResponse, ApiErrorResponse>({
        path: `/article-service/api/announcements/tenant`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name CreateCorporationAnnouncementAsync
     * @summary Request is used to create corporation announcement
     * @request POST:/article-service/api/announcements/corporation
     * @secure
     */
    createCorporationAnnouncementAsync: (data: AnnouncementCreateRequest, params: RequestParams = {}) =>
      this.http.request<AnnouncementResponse, ApiErrorResponse>({
        path: `/article-service/api/announcements/corporation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name UpdateSeverityAsync
     * @summary Request is used to update announcement severity
     * @request PUT:/article-service/api/announcements/{id}/severity
     * @secure
     */
    updateSeverityAsync: (id: number, data: AnnouncementSeverityUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/article-service/api/announcements/${id}/severity`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name UpdateStatusAsync
     * @summary Request is used to update announcement status
     * @request PUT:/article-service/api/announcements/{id}/status
     * @secure
     */
    updateStatusAsync: (id: number, data: ArticleStatusUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/article-service/api/announcements/${id}/status`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name GetUnreadAsync
     * @summary Request is used to get unread announcements
     * @request GET:/article-service/api/announcements/unread
     * @secure
     */
    getUnreadAsync: (
      query?: {
        /**
         *
         *
         * 1 = Mobile
         *
         * 2 = Web
         *
         * 255 = All
         */
        platform?: AnnouncementPlatform
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AnnouncementResponse[], ApiErrorResponse>({
        path: `/article-service/api/announcements/unread`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name MarkAsReadAsync
     * @summary Request is used to mark announcements as read
     * @request POST:/article-service/api/announcements/mark-as-read
     * @secure
     */
    markAsReadAsync: (data: AnnouncementsMarkAsReadRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/article-service/api/announcements/mark-as-read`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  contentTrainingMaterials = {
    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name GetAllAsync
     * @summary Request is used to get assiged content training materials
     * @request GET:/article-service/api/content-training-materials
     * @secure
     */
    getAllAsync: (
      query?: {
        /** @default "" */
        search?: string
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         * @default 50
         */
        take?: number
        /** @format int32 */
        contentId?: number
        /** @default false */
        fetchContentNames?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ContentTrainingMaterialResponsePagedItemsResponse, ApiErrorResponse>({
        path: `/article-service/api/content-training-materials`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name AttachAsync
     * @summary Request is used to attach training material to content
     * @request POST:/article-service/api/content-training-materials
     * @secure
     */
    attachAsync: (data: TrainingMaterialAttachRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/article-service/api/content-training-materials`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name GetAsync
     * @summary Request is used to get content training material
     * @request GET:/article-service/api/content-training-materials/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<ContentTrainingMaterialResponse, ApiErrorResponse>({
        path: `/article-service/api/content-training-materials/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name DetachAsync
     * @summary Request is used to detach training material from content
     * @request DELETE:/article-service/api/content-training-materials/{id}
     * @secure
     */
    detachAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/article-service/api/content-training-materials/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name GetUsersAssignedToTrainingMaterialAsync
     * @summary Request is used to get users assigned to content training material
     * @request GET:/article-service/api/content-training-materials/{id}/users
     * @secure
     */
    getUsersAssignedToTrainingMaterialAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<ContentTrainingMaterialUserResponse[], ApiErrorResponse>({
        path: `/article-service/api/content-training-materials/${id}/users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name AssignUsersToTrainingMaterialsAsync
     * @summary Request is used to assign content training material to users
     * @request POST:/article-service/api/content-training-materials/{id}/users
     * @secure
     */
    assignUsersToTrainingMaterialsAsync: (
      id: number,
      data: ContentTrainingMaterialUsersAssignRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/article-service/api/content-training-materials/${id}/users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name GetUnreadCountAsync
     * @summary Request is used to get count of unread content training materials
     * @request GET:/article-service/api/content-training-materials/unread/count
     * @secure
     */
    getUnreadCountAsync: (
      query: {
        /** @format int32 */
        contentId: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/article-service/api/content-training-materials/unread/count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentTrainingMaterials
     * @name MarkAsReadAsync
     * @summary Request is used to mark content training material as read
     * @request POST:/article-service/api/content-training-materials/mark-as-read
     * @secure
     */
    markAsReadAsync: (data: ContentTrainingMaterialMarkAsReadRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/article-service/api/content-training-materials/mark-as-read`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  trainingMaterials = {
    /**
     * No description
     *
     * @tags TrainingMaterials
     * @name GetAllAsync
     * @summary Request is used to get training materials
     * @request GET:/article-service/api/training-materials
     * @secure
     */
    getAllAsync: (
      query?: {
        /** @default "" */
        search?: string
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         * @default 50
         */
        take?: number
        /** @format int32 */
        contentId?: number
        /** @default false */
        attach?: boolean
        /** @default false */
        assigned?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<TrainingMaterialBaseResponsePagedItemsResponse, ApiErrorResponse>({
        path: `/article-service/api/training-materials`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingMaterials
     * @name CreateAsync
     * @summary Request is used to create training material
     * @request POST:/article-service/api/training-materials
     * @secure
     */
    createAsync: (data: TrainingMaterialCreateRequest, params: RequestParams = {}) =>
      this.http.request<TrainingMaterialResponse, ApiErrorResponse>({
        path: `/article-service/api/training-materials`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingMaterials
     * @name GetAsync
     * @summary Request is used to retrieve training material by id
     * @request GET:/article-service/api/training-materials/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<TrainingMaterialResponse, ApiErrorResponse>({
        path: `/article-service/api/training-materials/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingMaterials
     * @name UpdateAsync
     * @summary Request is used to update training material
     * @request PUT:/article-service/api/training-materials/{id}
     * @secure
     */
    updateAsync: (id: number, data: TrainingMaterialUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/article-service/api/training-materials/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingMaterials
     * @name DeleteAsync
     * @summary Request is used to delete training material
     * @request DELETE:/article-service/api/training-materials/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/article-service/api/training-materials/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
}
